import { Modal } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledModal = styled(Modal)(
  ({ theme: { spacing, palette, colors, customVars } }) => ({
    '&.MuiModal-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    /** Content of Modal */
    ' .content': {
      maxWidth: spacing(69.6),
      maxHeight: '82vh',
      borderRadius: spacing(0.4),
      boxShadow: customVars.cardShadow,
      zIndex: '1',
      backgroundColor: palette.common.white,
    },
    /** Header of Modal */
    ' .modal-header': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minWidth: '69.6rem',
      padding: spacing(1.6, 1.6, 1.6, 2.4),
      borderBottom: `${spacing(0.1)} solid ${colors.container as string}`,
    },
  })
);
